import { gql } from '@apollo/client';

export const LICENSE_ISSUES_EXTERNAL_FILTERS = gql`
  query licenseIssuesExternalFilters($args: LicenseIssuesExternalFiltersInput!) {
    licenseIssuesExternalFilters(args: $args) {
      resolved
      inReview
      unreviewed
      blocker
      major
      minor
      types {
        type
        count
      }
    }
  }
`;

export const LICENSE_ISSUES = gql`
  query licenseIssues($args: LicenseIssuesInput!) {
    licenseIssues(args: $args) {
      edges {
        cursor
        node {
          issueId
          issueName
          issueDescription
          potentialSolution
          severity
          license {
            licenseName
            licenseUrl
            licenseType
            spdxId
            url
            additionalInfoUrlsList
            licenseNotes
          }
          componentName
          componentVersion
          componentId
          remediation {
            detail
            user
            createdTime
          }
          lastModified
          status
          evidence {
            componentId
            name
            version
            packageType
            vendor
            licenseName
            spdxId
            children
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        totalCount
      }
    }
  }
`;

export const LICENSE_ISSUE = gql`
  query licenseIssue($args: LicenseIssueInput!) {
    licenseIssue(args: $args) {
      issueId
      issueName
      issueDescription
      potentialSolution
      severity
      license {
        licenseName
        licenseUrl
        licenseType
        spdxId
        url
        additionalInfoUrlsList
        licenseNotes
      }
      componentName
      componentVersion
      componentId
      remediation {
        detail
        user
        createdTime
      }
      lastModified
      status
      evidence {
        componentId
        name
        version
        packageType
        vendor
        licenseName
        spdxId
        children
      }
    }
  }
`;

export const REMEDIATE_LICENSE_ISSUES = gql`
  mutation remediateLicenseIssues($args: RemediateLicenseIssuesInput!) {
    remediateLicenseIssues(args: $args) {
      err
    }
  }
`;

export const GET_LICENSES_SPDX_IDS = gql`
  query licensesSpdxIds {
    licensesSpdxIds
  }
`;
